module.exports = __webpack_public_path__ + "media/video_eraser.7a99d23d.mp4";